import * as helpers from './helpers';
import React, {PropTypes} from 'react';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const RecoveryPercentageIcon = (props, context) => {

    const className = `recovery-percentage-icon ${helpers.displayIconForRecoveryPercentage(
        props.recoveryPercentage,
        {
            red: context.user.settings.reimbursementSummary.reimbursedPercentIndicator.red,
            yellow: context.user.settings.reimbursementSummary.reimbursedPercentIndicator.yellow
        }
    )}`;

    return (
        <span
            className={className}
        ></span>
    );

};

RecoveryPercentageIcon.displayName = 'RecoveryPercentageIcon';
RecoveryPercentageIcon.propTypes = {
    recoveryPercentage: PropTypes.number.isRequired
};
RecoveryPercentageIcon.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default RecoveryPercentageIcon;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/recovery-percentage-icon.js